import api from "APP_ROOT/api";
import { ACTIVE, CREDIT_HOLD, NO_BIZ } from "MODULES/companies/constants";
import { SUCCESS } from "LIB/submission";
import { push } from "react-router-redux";
import { ID } from "APP_ROOT/constants";
import { toastr } from "react-redux-toastr";
import { CONSIGNMENT } from "MODULES/Receiving/constants";
import * as actionTypes from "./actionTypes";

export function create(data) {
  return dispatch =>
    api.consignments.create(data).then(resp => {
      const id = resp.data.id;
      dispatch(
        push({
          pathname: `/consignments/${id}`
        })
      );
      return SUCCESS;
    });
}

export function importLineItems(values) {
  return (dispatch, getState) => {
    const id = getState().consignmentDetail.getIn([CONSIGNMENT, ID]);
    const fileName = values.file.name;

    return api.attachments.upload(values.file.name).then(resp => {
      const { key, url } = resp.data;
      const formattedAttachment = {
        name: fileName,
        key
      };

      return api.attachments
        .toS3(url, values.file)
        .then(() =>
          api.consignments.import(id, formattedAttachment).then(() => {
            show(id);
            toastr.info("Processing", "Importing Consignment.");
            return SUCCESS;
          })
        )
        .catch(e => Promise.reject(e));
    });
  };
}

export function searchBuyers(filter) {
  return () =>
    api.users
      .search({ active: true, filter, page: 1, limit: 10 })
      .then(resp => Promise.resolve(resp.data.results));
}

export function searchCompanies(filter) {
  return () =>
    api.companies
      .search({
        filter,
        status: [ACTIVE, NO_BIZ, CREDIT_HOLD].join(","),
        sort: "name",
        reverse: false,
        page: 1,
        limit: 20
      })
      .then(resp => Promise.resolve(resp.data.results));
}

export function show(id) {
  return dispatch =>
    api.consignments.show(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        consignment: resp.data
      });
    });
}

export function update(data) {
  return (dispatch, getState) => {
    const id = getState().consignmentDetail.getIn(["consignment", "id"]);

    return api.consignments.update(id, data).then(({ data: consignment }) => {
      dispatch({ type: actionTypes.SET, consignment });
      return SUCCESS;
    });
  };
}



// WEBPACK FOOTER //
// ./app/modules/Consignments/actions.js